import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh', padding:40, textAlign:'center' }}>
      <div>
        <div style={{ fontFamily:"'JetBrains Mono', monospace", fontSize:64, fontWeight:300, color:'#E2E8F0', lineHeight:1 }}>404</div>
        <div style={{ fontFamily:"'Fraunces', serif", fontSize:20, fontWeight:600, color:'#0D1B2A', marginTop:16 }}>Off the chart</div>
        <div style={{ fontSize:13, color:'#64748B', marginTop:8, marginBottom:24 }}>This page doesn't exist in our intelligence database.</div>
        <button onClick={() => navigate('/')} style={{
          background:'#0D1B2A', color:'#fff', border:'none', borderRadius:8,
          padding:'10px 20px', fontSize:13, fontWeight:500, cursor:'pointer',
          fontFamily:"'Figtree', sans-serif",
        }}>
          Return to Dashboard
        </button>
      </div>
    </div>
  );
}
